import { copyToClipboard } from '../../js/shared/utils';

document.addEventListener('click', (e) => {
    // example: components.html

    const targetElement = e.target.closest('.js-clipboard-btn');
    if (!targetElement) {
        return;
    }

    const parent = targetElement.closest('.js-clipboard');
    if (!parent) {
        return;
    }

    const copyElement = parent.querySelector('.js-clipboard-textcontent');
    const defaultEl = parent.querySelector('.js-clipboard-default');
    const secondaryEl = parent.querySelector('.js-clipboard-replace');

    if (copyElement) {
        const text = copyElement.textContent;

        if (text) {
            copyToClipboard(text);

            if (defaultEl && secondaryEl) {
                parent.classList.add('is-disable-clicked');
                setTimeout(function () {
                    parent.classList.remove('is-disable-clicked');
                }, 3000);
            }
        }


    }


});